import { List } from 'immutable';

import { composeStateMachine } from '../module';

import { composeInitialState } from '../../composeActions';
import { IQueueEffectPayload } from '../../types';

export const effectInitialState = composeInitialState({
  queued: List<IQueueEffectPayload<any, any, any>>()
});

export const effectState = composeStateMachine('effects', effectInitialState, compose => ({
  queueEffect: compose.action((state, effect: IQueueEffectPayload<any, any, any>) =>
    state.update('queued', queued => queued.push(effect))
  ),

  removeFromQueue: compose.action((state, effects: IQueueEffectPayload<any, any, any>[]) =>
    state.update('queued', queued => queued.filter(eff => effects.indexOf(eff) === -1))
  )
}));

export const {
  actions: effectActions,
  actionCreators: effectActionCreators,
  selector: effectSelector,
  branchKey: effectBranchKey,
  reducer: effectReducer
} = effectState;
